import {ThemeMode, themeModeAtom} from "@/store/jotaiAtoms";
import {useAtom} from "jotai";
import {useEffect} from "react";

const DARK_QUERY = "(prefers-color-scheme: dark)";

const resolve = (mode: ThemeMode): "light" | "dark" => {
  if (mode === "system") {
    return window.matchMedia(DARK_QUERY).matches ? "dark" : "light";
  }
  return mode;
};

export const useTheme = () => {
  const [mode, setMode] = useAtom(themeModeAtom);

  useEffect(() => {
    const apply = (next: ThemeMode) => document.documentElement.classList.toggle("dark", resolve(next) === "dark");

    apply(mode);
    if (mode !== "system") return;

    const media = window.matchMedia(DARK_QUERY);
    const listener = () => apply("system");
    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, [mode]);

  return {mode, resolvedTheme: resolve(mode), setMode};
};
